import '../../../../assets/css/screens/serviceprovider/dashboard/workerhome/WorkerHome.css';
import React, { useContext, useState, useEffect, useRef
 } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
import AppContext from '../../../../context/AppContext';
import MyNavbar from '../../../../components/serviceprovider/workerdashboard/Workernavbar/WorkerNavbar';
import echo from '../../../../config/echo';
import WorkerHomeSkeleton from "../../../../components/skeltonloading/WorkerHomeSkeleton";

// ── Import Broken-down Components ──
import WorkerHero from '../../../../subscreens/serviceprovider/dashboard/workerdashboard/workerhome/WorkerHero';
import WorkerStats from '../../../../components/serviceprovider/workerdashboard/worerhome/WorkerStats';
import ActiveJobsSection from '../../../../subscreens/serviceprovider/dashboard/workerdashboard/workerhome/ActiveJobsSection';
import NewJobsSection from '../../../../subscreens/serviceprovider/dashboard/workerdashboard/workerhome/NewJobsSection';


const WorkerHome = () => {

  const { baseUrl, authToken, kycStatus, baseUrlForFile , workerProfile} = useContext(AppContext);
  const navigate = useNavigate();
const [availabilityLoading, setAvailabilityLoading] = useState(false);
  const [dashboard, setDashboard] = useState(null);
  // const availablity = dashboard?.stats?.availability == 1;
  const [availablity, setAvailablity] = useState();
  const [loading, setLoading] = useState(true);
  const [unreadCount, setUnreadCount] = useState(0);
  const receivedNotifications = useRef(new Set());


  const hour = new Date().getHours();
  const greeting = hour < 12 ? 'Good Morning' : hour < 17 ? 'Good Afternoon' : 'Good Evening';
  const emoji = hour < 12 ? '🌅' : hour < 17 ? '👋' : '🌙';
  // fetch activejobs
 
useEffect(() => {
setLoading(true);
    console.log("WorkerHome Mounted");

    const start = performance.now();

    axios.get(`${baseUrl}/worker/dashboard`, {
        headers: {
    Authorization: `Bearer ${localStorage.getItem("authToken")}`
}
    })
.then((res) => {
    setDashboard(res.data);
    setAvailablity(res.data.stats.availability == 1);
})
    .catch((err) => {
        const end = performance.now();
        console.log("Dashboard Failed After:", (end - start).toFixed(2), "ms");
        console.log(err);
    })
    .finally(() => {
    setLoading(false);
});

}, [baseUrl, authToken]);


useEffect(() => {

    const getUnreadCount = () => {

     axios.get(
 `${baseUrl}/worker/unread/count`,
 {
  headers:{
    Authorization:`Bearer ${authToken}`
  }
 }
)
.then(res => {
 console.log("API Response:", res.data);
 console.log("Unread Count:", res.data.count);

 setUnreadCount(res.data.count);
})
        .catch(err=>{
            console.log(err);
        });

    };


    getUnreadCount();


}, [baseUrl, authToken]);
  


// sockets
useEffect(()=>{

    if(!workerProfile?.id) {
        console.log("Worker profile not loaded");
        return;
    }


    const channelName = `worker-${workerProfile.id}`;

    console.log("Joining worker channel:", channelName);


if (!echo) {
    console.error("❌ Echo is undefined in WorkerHome");
    return;
}

if (typeof echo.channel !== "function") {
    console.error("❌ echo.channel is unavailable in WorkerHome", echo);
    return;
}

const channel = echo.channel(channelName);

    channel.listen('.NotificationUpdates',(event)=>{

        console.log("New Notification:", event);


        setUnreadCount(prev => prev + 1);

    });


    return ()=>{

        console.log("Leaving:", channelName);

        echo.leave(channelName);

    };


},[workerProfile?.id]);

//  const handleAvailablityToggle = () => {

//     const newValue = !availablity;

//     // UI update
//     setAvailablity(newValue);

//     // LocalStorage update
//     localStorage.setItem("availability", newValue ? "1" : "0");

//     setAvailablity(newValue);

//     const formData = new FormData();
//     formData.append("availablity", newValue ? 1 : 0);

//     axios.post(
//         `${baseUrl}/worker/updatesetting`,
//         formData,
//         {
//             headers: {
//                 Authorization: `Bearer ${authToken}`
//             }
//         }
//     )
//     .then(() => {
//         setDashboard(prev => ({
//             ...prev,
//             stats: {
//                 ...prev.stats,
//                 availability: newValue ? 1 : 0
//             }
//         }));
//     })
//     .catch(() => {
//         setAvailablity(!newValue);
//     });
// };
const handleAvailablityToggle = () => {

    if (availabilityLoading) return;

    const newValue = !availablity;

    // UI update
    setAvailablity(newValue);
    localStorage.setItem("availability", newValue ? "1" : "0");

    const formData = new FormData();
    formData.append("availablity", newValue ? 1 : 0);

    setAvailabilityLoading(true);
console.log("Context authToken:", authToken);
console.log("LocalStorage authToken:", localStorage.getItem("authToken"));
    axios.post(
        `${baseUrl}/worker/updatesetting`,
        formData,
        {
            headers: {
                Authorization: `Bearer ${authToken}`
            }
        }
    )
    .then(() => {
        setDashboard(prev => ({
            ...prev,
            stats: {
                ...prev.stats,
                availability: newValue ? 1 : 0
            }
        }));
    })
    .catch((err) => {
    console.log(err);
    console.log(err.response?.status);
    console.log(err.response?.data);

    setAvailablity(!newValue);
})
    .finally(() => {
        setAvailabilityLoading(false);
    });
};
if (loading) {
    return <WorkerHomeSkeleton />;
}
  return (
    <div className="wh-page">
      {/* <MyNavbar /> */}

      {/* ══ MOBILE HERO ══ */}
    <WorkerHero
    ProfileImage={
        dashboard?.profile?.ProfileImage
        ? `${baseUrlForFile}/${dashboard.profile.ProfileImage}`
        : null
    }
    fullName={dashboard?.profile?.fullName}
    greeting={greeting}
    emoji={emoji}
    jobsDone={dashboard?.stats?.jobsDone}
    address={dashboard?.profile?.address}

    availablity={availablity}
    handleAvailablityToggle={handleAvailablityToggle}
    availabilityLoading={availabilityLoading}

    unreadCount={unreadCount}
/>

      {/* ══ DESKTOP HEADER + CLICKABLE STATS ══ */}
    <WorkerStats
    availablity={availablity}
    handleAvailablityToggle={handleAvailablityToggle}
    stats={dashboard?.stats}
/>

      {/* ══ ACTIVE JOBS ══ */}
 {availablity && (
    <ActiveJobsSection
        kycStatus={dashboard?.kyc?.status}
        activeJobs={dashboard?.activeJobs || []}
    availablity={availablity}
    handleAvailablityToggle={handleAvailablityToggle}
    stats={dashboard?.stats}
    availabilityLoading={availabilityLoading}

    />
)}

      {/* ══ NEW JOB POSTINGS ══ */}
      <NewJobsSection
        kycStatus={kycStatus}
      newJobs={dashboard?.newJobs || []}
      />

    </div>
  );
};

export default WorkerHome;